import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import ProviderUtils from "../../utils/provider.utils";
import apiClient from "../../utils/apiClient";
import Provider from "../../enum/Provider.enum";

export interface AppState {
  isDebug: boolean;
  provider: Provider;
  settingsLoading: boolean;
  settings: Record<string, any>;
}

const initialState: AppState = {
  isDebug: ProviderUtils.getIsDebug(),
  provider: ProviderUtils.getProvider(),
  settingsLoading: false,
  settings: {},
};

export const loadSettings = createAsyncThunk(
  "app/loadSettings",
  async (_, { getState }) => {
    try {
      const response = await apiClient.get("/settings");
      if (response.data.success) {
        delete response.data.success;
        return response.data;
      }
    } catch (error) {
      console.error("Ошибка запроса настроек:", error);
    }

    throw new Error("Failed to load settings");
  },
);

const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    setDebug(state, action: PayloadAction<boolean>) {
      const isDebug = action.payload;
      state.isDebug = isDebug;

      if (!isDebug) {
        console.warn("console.log is disabled in prod mode");
        console.log = function () {};
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loadSettings.pending, (state) => {
        state.settingsLoading = true;
      })
      .addCase(loadSettings.fulfilled, (state, action) => {
        state.settings = action.payload ?? {};
        state.settingsLoading = false;
      })
      .addCase(loadSettings.rejected, (state, action) => {
        state.settingsLoading = false;
        console.error("appSlice settingsLoading.rejected", action);
      });
  },
});

export const { setDebug } = appSlice.actions;

export default appSlice;
